import type { ConfigurationEntity } from '../../domain/entities/ConfigurationEntity.js';
import type { IConfigurationRepository, UpsertConfigurationInput } from '../../domain/repositories/IConfigurationRepository.js';
import type { ConfigurationRemoteDataSource } from '../datasources/ConfigurationRemoteDataSource.js';
import type { ConfigurationDto } from '../dtos/ConfigurationDto.js';

function mapDto(dto: ConfigurationDto): ConfigurationEntity {
  return {
    id: dto.id,
    orgId: dto.org_id,
    projectId: dto.project_id,
    featureName: dto.feature_name,
    settings: dto.settings,
    description: dto.description,
  };
}

export class ConfigurationRepository implements IConfigurationRepository {
  constructor(private readonly ds: ConfigurationRemoteDataSource) {}

  async list(orgId: string, projectId?: string | null): Promise<ConfigurationEntity[]> {
    return (await this.ds.list(orgId, projectId)).map(mapDto);
  }

  async upsert(input: UpsertConfigurationInput): Promise<ConfigurationEntity> {
    const dto = await this.ds.upsert({
      org_id: input.orgId,
      project_id: input.projectId,
      feature_name: input.featureName,
      settings: input.settings,
      description: input.description ?? null,
    });
    if (!dto) throw new Error('Configuration upsert failed');
    return mapDto(dto);
  }

  async delete(id: string): Promise<void> {
    await this.ds.delete(id);
  }
}
